import {getDominantBlockType, withX, withType, getBlocks} from '../calculateRules.js';
import {doc} from './docs.js';
import {byX, byY} from './utils.js';

// todo: deleteBlock (completely deletes a new block)
// complimentarly need a "newBlock"
doc(
    "delete",
    {
        "blockNumber": "block to delete from",
    },
    "Deletes a cell in block inside the grid "
);
export const deleteCell = (grid, blockNumber) => {
    let {cells, size} = grid;
    let blocks = getBlocks(cells, size);

    if (!blocks || isNaN(blockNumber)) {
        return;
    }

    // filter blocks that have more than 1 
    blocks = blocks.filter(b => b.length > 1);

    let block = blocks[blockNumber % blocks.length];
    if (!block) {
        return;
    }

    block = block.filter(({x,y}) => cells[y] && cells[y][x] !== '-' && cells[y][x] !== '.');

    let blockByY = byY(block);
    let xValues = Object.keys(blockByY).map(k => parseInt(k));
    let maxY = Math.max(... xValues);
    if (!blockByY[maxY]) {
        return;
    }
    let {x,y} = blockByY[maxY][0];
    grid.set(x,y, false);
}

// todo: deleteBlock (completely deletes a new block)
// complimentarly need a "newBlock"
doc(
    "clearBlock",
    {
        "blockNumber": "block to clear",
        "ratio": "block to clear (0-1)",
    },
    "Deletes all cells in a block "
);
export const clearBlock = (grid, blockNumber, ratio=1) => {
    let {cells, size} = grid;
    let blocks = getBlocks(cells, size);

    if (!blocks || isNaN(blockNumber)) {
        return;
    }

    // filter blocks that have more than 1 
    blocks = blocks.filter(b => b.length > 1);

    let block = blocks[blockNumber % blocks.length];
    if (!block) {
        return;
    }

    block = block.filter(({x,y}) => cells[y] && cells[y][x] !== '-' && cells[y][x] !== '.');


    let toDelete = Math.floor(ratio*block.length);
    block.slice(0, toDelete).forEach(({x,y}) => 
        grid.set(x,y, false));
}


